{
  "instances": {
    "metrics": {
      "label": "Метрики",
      "add_metric": "Добавить метрику",
      "fetching_tags": "Получение доступных тегов",
      "no_tags": "(без тегов)",
      "no_tags_available": "Теги недоступны.",
      "metrics_not_supported_spring_boot_1": "Метрики не поддерживаются для приложений на Spring Boot 1.x."
    }
  }
}
